import { render, staticRenderFns } from "./releaseLayout.vue?vue&type=template&id=6f9be9f8&scoped=true&"
import script from "./releaseLayout.vue?vue&type=script&lang=js&"
export * from "./releaseLayout.vue?vue&type=script&lang=js&"
import style0 from "./releaseLayout.vue?vue&type=style&index=0&id=6f9be9f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9be9f8",
  null
  
)

export default component.exports